import { Stack, Skeleton, Flex, Box, HStack } from '@chakra-ui/react';
import React from 'react';

function SkeletonCommentItem() {
  const commonProps = {
    fadeDuration: 5,
    borderRadius: 0,
  };
  return (
    <HStack
      spacing="12px"
      padding="16px"
      border="1px dashed"
      borderColor="brand.main"
      alignItems="flex-start"
    >
      <Skeleton {...commonProps} height="30px" width="30px" />
      <Stack spacing="12px">
        <Skeleton {...commonProps} height="16px" width="100px" />
        <Skeleton {...commonProps} height="16px" width="300px" maxWidth="100%" />
      </Stack>
    </HStack>
  );
}

export default SkeletonCommentItem;
